import React, { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { selectIsUserAuthenticated } from 'features/auth/selectors'

import './TopBannerHoc.scss'

const b = block('top-banner-hoc')

interface ITopBannerHoc {
  isShowNotification: boolean
  needAuth?: boolean
  allPromotionsIsExpired: boolean
  onCloseBanner: () => void
}

export const TopBannerHoc: React.FC<ITopBannerHoc> = props => {
  const { children, isShowNotification, needAuth = false, allPromotionsIsExpired, onCloseBanner } = props

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const checkAuth = needAuth ? isAuth : !needAuth

  useEffect(() => {
    if (!checkAuth) {
      onCloseBanner()
    }

    document.body.style.setProperty('--banner-height', `${checkAuth && isShowNotification ? '67px' : '0px'}`)

    if (!isShowNotification || allPromotionsIsExpired) {
      document.body.style.setProperty('--banner-height', '0px')
    }

    return () => {
      document.body.style.setProperty('--banner-height', '0px')
    }
  }, [isShowNotification, isAuth, allPromotionsIsExpired, checkAuth, onCloseBanner])

  return (
    <>
      {isShowNotification && !allPromotionsIsExpired ? (
        <div className={b()}>
          <div className={b('wrapper')}>
            {children}
            <div className={b('close-block')} onClick={onCloseBanner}>
              <span className={b('close-icon')}>×</span>
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}
